module.exports = __webpack_public_path__ + "img/document-fill.ae97bfb7.svg";